import { render, staticRenderFns } from "./ImageEffectsPropertiesListItemEdit.vue?vue&type=template&id=5996cf45"
import script from "./ImageEffectsPropertiesListItemEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEffectsPropertiesListItemEdit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports